<template>
  <div>
    <div class="map-container">
      <div class="map">
        <FieldMap :center="latLng" :zoom="13" ref="map" mini>
          <SinglePointPin :data="data" />
        </FieldMap>
      </div>
    </div>
    <vs-text>{{ latLng.lat }}, {{ latLng.lng }}</vs-text>
  </div>
</template>

<script setup lang="ts">
import FieldMap from '@/components/field-view-next/mapbox/FieldMap.vue'
import SinglePointPin from '@/components/field-view-next/layers/SinglePointPin.vue'
import { pointToLatLng, pointToMapData } from '@/utils/forms/point-helper'
import { computed } from 'vue'

const props = defineProps<{ value: string }>()

const latLng = computed(() => pointToLatLng(props.value))
const data = computed(() => pointToMapData(props.value))
</script>

<style scoped>
.map-container {
  border-radius: var(--space-base);
  overflow: hidden;
  padding-top: 2px;
  padding-bottom: 2px;
}

.map {
  height: 320px;
}
</style>
